import { render } from "./ViewAllRestaurants.vue?vue&type=template&id=2c154ab8&scoped=true"
import script from "./ViewAllRestaurants.vue?vue&type=script&lang=js"
export * from "./ViewAllRestaurants.vue?vue&type=script&lang=js"

import "./ViewAllRestaurants.vue?vue&type=style&index=0&id=2c154ab8&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c154ab8"]])

export default __exports__